import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LoginModule } from './pages/pages/auth/login/login.module';
import { HttpsInterceptor } from 'src/shared/interceptor/http.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPersianPaginatorIntl } from '../shared/paginator/paginator-fa';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TableLoaderInterceptor } from '../shared/interceptor/table-loader.interceptor';
import { NgxUiLoaderConfig, NgxUiLoaderModule, SPINNER} from 'ngx-ui-loader';
import { FooterModule } from "src/@vex/layout/footer/footer.module";
import { AlertDeleteModule } from 'src/shared/alert-delete/alert-delete.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from './pages/pages/auth/login/service/auth.service';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {

  fgsType: SPINNER.squareJellyBox,
  fgsSize: 0,
  fgsColor: 'transparent',

  bgsType: SPINNER.squareJellyBox,
  bgsSize: 0,
  bgsColor: 'transparent',

  logoUrl: 'assets/img/illustrations/35.png',
  logoSize: 50,
  logoPosition: 'center-center',

  overlayColor: 'rgba(40, 40, 40, 0.8)',
  blur: 5,
  hasProgressBar: false,

  text: 'لطفا کمی صبر کنید',
  textColor: '#FFFFFF',
  textPosition: 'center-center'
};



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ToastrModule.forRoot({ positionClass: 'toast-bottom-center',
    }),
    AlertDeleteModule,
    NgMultiSelectDropDownModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    MatCheckboxModule,
    LoginModule,
    MatInputModule,
    // Vex
    VexModule,
    CustomLayoutModule,
    NgxPermissionsModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    FooterModule,

    // Vex
  ],
    providers: [
    // { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
    {
      provide: APP_INITIALIZER,
      useFactory: initRoles,
      deps: [NgxPermissionsService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TableLoaderInterceptor,
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useFactory: getPersianPaginatorIntl
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsInterceptor,
      multi: true,
    },
    {
  provide: APP_INITIALIZER,
  useFactory: appInitializerFactory,
  deps: [AuthService],
  multi: true
},
{
  provide: APP_INITIALIZER,
  useFactory: initApp,
  deps: [AuthService],
  multi: true
}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
function initRoles(ngxPermissionsService: NgxPermissionsService) {
  return () => {
    return new Promise((resolve) => {
      const accesses = localStorage.getItem('system-management')
      if (accesses) {
        ngxPermissionsService.loadPermissions(accesses.split(','))
      }
      resolve(true);
    })
  };
}
export function initApp(auth: AuthService) {
  return () => auth.initializeApp();
}


export function appInitializerFactory(authService: AuthService) {
  return () => authService.initializeApp();
}